import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

const Footer = (props: React.ButtonHTMLAttributes<HTMLDivElement>): ReactElement => {
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  return (
    <div {...props}>
      <span style={{ color: "white" }}>{t("footer.copyright", { year: currentYear })}</span>
      &nbsp;
    </div>
  );
};

export default Footer;
